/**
 * RNG deterministico iniettato ovunque nel motore.
 * Nessun accesso a Math.random/Date.now dentro src/game/:
 * stessa seed => stessa run (daily, verify-replay, test, simulatore, ghost).
 * Copiato dal fratello TILT — stesso stack, stesse garanzie.
 */

export type Rng = () => number;

/** mulberry32 — veloce, 32 bit di stato, distribuzione più che adeguata per un gioco. */
export function mulberry32(seed: number): Rng {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** xmur3 — hash di stringa a 32 bit: trasforma seed testuali ("wake-2026-07-08") in numeri. */
export function hashSeed(str: string): number {
  let h = 1779033703 ^ str.length;
  for (let i = 0; i < str.length; i++) {
    h = Math.imul(h ^ str.charCodeAt(i), 3432918353);
    h = (h << 13) | (h >>> 19);
  }
  h = Math.imul(h ^ (h >>> 16), 2246822507);
  h = Math.imul(h ^ (h >>> 13), 3266489909);
  return (h ^= h >>> 16) >>> 0;
}

export function rngFromString(seed: string): Rng {
  return mulberry32(hashSeed(seed));
}
